import apiPath from "./apiPath";

/* global localStorage */
const axios = require("axios");

function getHeaders() {
  return { "Content-Type": "application/json" };
}
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 1000,
  headers: getHeaders(),
});

let excludePath = ['/driver-manager/edit', '/driver-manager/add','/dashboard','/']
let activeRequests = 0;

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return config;
  }

  if (!excludePath?.includes(window?.location?.pathname)) {
    if (activeRequests === 0) {
      document.getElementById("loader")?.classList.remove("hidden");
    }
    activeRequests++;
  }

  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` },
  };
  return config;
});

instance.interceptors.response.use(
  function (response) {
    activeRequests = Math.max(activeRequests - 1, 0);
    if (activeRequests === 0) {
      document.getElementById("loader")?.classList.add("hidden");
    }
    return response;
  },
  async function (error) {
    const { status } = error.response;
    if (status === 401 && localStorage.getItem('refresh_token')) {
      const path = apiPath.getRefreshToken;
      const result = await apiPost(path, { refreshToken: localStorage.getItem('refresh_token') });
      if (result?.data?.success) {
        window?.localStorage.setItem('token', result?.data?.results?.token)
        window?.localStorage.setItem('refresh_token', result?.data?.results?.refreshToken)
        window.location.reload()
      }else{
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("uniqueId");
        window.location = "/login";
      }

    }else if ( status === 403 || status === 409) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("uniqueId");
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

function apiGet(url, params = {}) {
  return instance.get(url, { params });
}

function apiPost(url, body) {
  return instance.post(url, body);
}

function apiPut(url, body) {
  return instance.put(url, body);
}

function apiDelete(url) {
  return instance.delete(url);
}

export { getHeaders, apiGet, apiPost, apiPut, apiDelete };
